import { createReducer, on } from '@ngrx/store';
import { RoutePermission } from '../../model/routePermission.model';
import * as RoutePermissionActions from '../actions/routePermission.actions';

export interface RoutePermissionState {
    routePermissions: RoutePermission[] | null;
    loading: boolean;
    error: string | null;
}

export const initialState: RoutePermissionState = {
    routePermissions: null,
    loading: false,
    error: null
};

export const routePermissionReducer = createReducer(
    initialState,
    
    // Load Route Permissions
    on(RoutePermissionActions.LoadRoutePermissions, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    
    on(RoutePermissionActions.LoadRoutePermissionsSuccess, (state, { routePermissions }) => ({
        ...state,
        routePermissions: routePermissions,
        loading: false,
        error: null
    })),
    
    on(RoutePermissionActions.LoadRoutePermissionsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error
    }))
);
